export default "__VITE_ASSET__ba155f6c__"